import React, { Component } from "react";

import Notification from "./notification.js";
import settings from "../../settings.js";
import { Link } from "react-router-dom";

import Scrollbars from "react-custom-scrollbars";

class THTNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_tht_products/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Clock} alt="" />
          </div>
          */}
          <div className="gridHeaderTitle">THT</div>

          <div className="gridHeaderAll"></div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((notification, index) => (
                <Notification data={notification} key={index} />
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <div className={"THT"}>
                <div>
                  <div className="THTTitle">Geen naderende THT producten</div>
                </div>
              </div>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default THTNotifications;
